import { render, staticRenderFns } from "./CommentBook.vue?vue&type=template&id=e71c3402&scoped=true&"
import script from "./CommentBook.vue?vue&type=script&lang=js&"
export * from "./CommentBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71c3402",
  null
  
)

export default component.exports